import { useEffect, useState } from 'react'
import { getTariffAuditHistoryApi } from '../../apis/apis'
import type { TariffAuditEntry } from '../../apis/types'

interface UseTariffAuditHistoryResult {
    auditHistory: TariffAuditEntry[]
    total: number
    isLoading: boolean
    error: string | null
}

export function useTariffAuditHistory(
    tariffId: string | undefined,
    page: number,
    refreshKey = 0
): UseTariffAuditHistoryResult {
    const [auditHistory, setAuditHistory] = useState<TariffAuditEntry[]>([])
    const [total, setTotal] = useState(0)
    const [isLoading, setIsLoading] = useState(false)
    const [error, setError] = useState<string | null>(null)

    useEffect(() => {
        setAuditHistory([])
        setTotal(0)
    }, [tariffId])

    useEffect(() => {
        if (tariffId == null) return

        let cancelled = false
        setIsLoading(true)
        setError(null)

        getTariffAuditHistoryApi(tariffId, {
            page,
            resultsPerPage: 25,
        })
            .then((data) => {
                if (cancelled) return
                setAuditHistory(data.results)
                setTotal(data.total ?? 0)
            })
            .catch(() => {
                if (!cancelled) setError('Failed to load activity log')
            })
            .finally(() => {
                if (!cancelled) setIsLoading(false)
            })

        return () => {
            cancelled = true
        }
    }, [tariffId, page, refreshKey])

    return { auditHistory, total, isLoading, error }
}
